import React, {
  memo,
} from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useTablePart } from '../../../../BaseEditor/tablePart/hook';
import TPCommandPanel from '../../../../BaseEditor/tablePart/commandPanels/materialCommandPanel';
import Row from './row';

function PrecentsTablePart({
  data, options, onChange, readOnly,
}) {
  const {
    displayedItems, fields, actions, permissions, activeRow,
    pages, currentPage, getControlTP,
  } = useTablePart({
    data, options, onChange, readOnly,
  });

  return (
    <>
      <TPCommandPanel
        actions={actions}
        permissions={permissions}
        pages={pages}
        currentPage={currentPage}
        activeRow={activeRow}
      />
      <TableContainer component={Paper}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: '5%' }} />
              <TableCell colSpan={4} align="center" style={{ width: '40%' }}>
                Земельні ділянки в оренді
              </TableCell>
              <TableCell colSpan={4} align="center" style={{ width: '40%' }}>
                Земельні ділянки у власності
              </TableCell>
              <TableCell style={{ width: '15%' }} />
            </TableRow>
            <TableRow>
              <TableCell style={{ width: '5%' }} />
              <TableCell colSpan={2} align="center">
                Нормативно грошова оцінка (НГО) проведена
              </TableCell>
              <TableCell colSpan={2} align="center">
                Ділянки за межами населених пунктів. НГО не проведено
              </TableCell>
              <TableCell colSpan={2} align="center">
                Нормативно грошова оцінка (НГО) проведена
              </TableCell>
              <TableCell colSpan={2} align="center">
                Ділянки за межами населених пунктів. НГО не проведено
              </TableCell>
              <TableCell style={{ width: '15%' }} />
            </TableRow>
            <TableRow>
              <TableCell align="center" style={{ width: '5%' }}>
                {fields.datefrom.label}
              </TableCell>
              <TableCell align="center" style={{ width: '10%' }}>
                юр.особи
              </TableCell>
              <TableCell align="center" style={{ width: '10%' }}>
                фіз.особи
              </TableCell>
              <TableCell align="center" style={{ width: '10%' }}>
                юр.особи
              </TableCell>
              <TableCell align="center" style={{ width: '10%' }}>
                фіз.особи
              </TableCell>
              <TableCell align="center" style={{ width: '10%' }}>
                юр.особи
              </TableCell>
              <TableCell align="center" style={{ width: '10%' }}>
                фіз.особи
              </TableCell>
              <TableCell align="center" style={{ width: '10%' }}>
                юр.особи
              </TableCell>
              <TableCell align="center" style={{ width: '10%' }}>
                фіз.особи
              </TableCell>
              <TableCell align="center" style={{ width: '15%' }}>
                {fields.locality.label}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedItems.map((row) => (
              <Row
                actions={actions}
                row={row}
                readOnly={readOnly}
                fields={fields}
                key={row.id}
                active={activeRow === row.id}
                getControlTP={getControlTP}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

PrecentsTablePart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
  })).isRequired,
  fields: PropTypes.shape({
    datefrom: PropTypes.shape({ label: PropTypes.string }),
    individual_value_1: PropTypes.shape({ label: PropTypes.string }),
    individual_value_2: PropTypes.shape({ label: PropTypes.string }),
    individual_value_3: PropTypes.shape({ label: PropTypes.string }),
    individual_value_4: PropTypes.shape({ label: PropTypes.string }),
    law_person_value_1: PropTypes.shape({ label: PropTypes.string }),
    law_person_value_2: PropTypes.shape({ label: PropTypes.string }),
    law_person_value_3: PropTypes.shape({ label: PropTypes.string }),
    law_person_value_4: PropTypes.shape({ label: PropTypes.string }),
    locality: PropTypes.shape({ label: PropTypes.string }),
  }).isRequired,
  options: PropTypes.shape({
    child: PropTypes.shape({
      children: PropTypes.shape(),
    }),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

PrecentsTablePart.defaultProps = {
  readOnly: false,
};

export default memo(PrecentsTablePart);
